export const SET_CURRENT_PAGE = 'SET_CURRENT_PAGE'
export const SHOW_HIDDEN_PAGE = 'SHOW_HIDDEN_PAGE'

export const SAVE_TEXT = 'SAVE_TEXT'
export const SAVE_URL_LIST = 'SAVE_URL_LIST'
export const SAVE_SELECTED_URL_LIST = 'SAVE_SELECTED_URL_LIST'

export const UPDATE_URL_LIST = 'UPDATE_URL_LIST'
export const UPDATE_ACCOUNT_LIST = 'UPDATE_ACCOUNT_LIST'

export const DELETE_URL_LIST = 'DELETE_URL_LIST'
export const DELETE_SELECTED_URL_LIST = 'DELETE_SELECTED_URL_LIST'
export const DELETE_DUPLICATE_URL_LIST = 'DELETE_DUPLICATE_URL_LIST'